import React, { useEffect, useId, useState } from 'react'
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import './styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FilterInterface } from '../../interfaces/entities/FilterInterface';
import { sxFilterSelect, sxMenuItem } from './sxProps';
import { FilterSelectProps } from '../../interfaces/props/SaudeOnline/FilterSelectProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { FormControl, InputLabel } from '@mui/material';

function FilterSelect(props: FilterSelectProps) {
  const [value, setValue] = useState<string>('');
  const [options, setOptions] = useState<FilterInterface[]>([]);

  const accessibility = useAccessibility();

  const uniqueId = useId();

  useEffect(() => {
    setOptions(props.options)
    if (props.value) {
      setValue(props.value);
    }
  }, [props.options])

  useEffect(() => {
    if (props.erase !== undefined) {
      setValue(props.value || '');
    }
  }, [props.erase])

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value)
    props.handleChange(event.target.value);
  };

  return (
    <div className={`select-holder`}>
      <FormControl fullWidth>
        <label style={accessibility.textStyleAccessibility} className='select-label'>{props.title}</label>
        <InputLabel
          id={`${uniqueId}-label`}
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            margin: '-1px',
            padding: '0',
            border: '0',
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            whiteSpace: 'nowrap',
          }}
        >
          {props.title}
        </InputLabel>
        <Select
          labelId={`${uniqueId}-label`}
          id={uniqueId}
          value={value}
          onChange={handleChange}
          fullWidth
          style={accessibility.textStyleAccessibility}
          sx={sxFilterSelect}
          IconComponent={(props) => (
            <FontAwesomeIcon
              style={{ color: accessibility.contrastMode ? 'white' : '' }}
              icon={faChevronDown}
              {...props}
              color={'#383838'}
            />
          )}
          displayEmpty
          renderValue={
            value !== ""
              ? undefined
              : () => <span className="placeholder">{props.placeholder || 'Selecione'}</span>
          }
          disabled={props.disabled}
        >
          {options.map((option) => (
            <MenuItem
              style={accessibility.textStyleAccessibility}
              key={`filter-${option.id}`}
              value={option.id}
              sx={sxMenuItem}
              aria-label={option.ariaDescricao || option.descricao}
            >
              {option.descricao}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default FilterSelect;